import { render } from "./protocol_winners.vue?vue&type=template&id=40d6c7a4&scoped=true"
import script from "./protocol_winners.vue?vue&type=script&lang=js"
export * from "./protocol_winners.vue?vue&type=script&lang=js"

import "./protocol_winners.vue?vue&type=style&index=0&id=40d6c7a4&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d6c7a4"],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_winners.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40d6c7a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40d6c7a4', __exports__)) {
    console.log('reload')
    api.reload('40d6c7a4', __exports__)
  }
  
  module.hot.accept("./protocol_winners.vue?vue&type=template&id=40d6c7a4&scoped=true", () => {
    console.log('re-render')
    api.rerender('40d6c7a4', render)
  })

}


export default __exports__